module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset> ';
 if ( transientSubscriptionPackage ) { 
__p+=' <legend>'+
((__t=( i18n.tc("PrepaidOption", "A dealer agreement is already selected") ))==null?'':__t)+
'</legend><p>'+
((__t=( i18n.tc("PrepaidOption", "Would you like to keep, change or remove the option?") ))==null?'':__t)+
'</p><div class="input"><div><input type="radio" name="prepaid-option" data-input="prepaid-option-radio" id="no" value="skip" checked="checked"> <label class="align-left" for="no">'+
((__t=( i18n.tc("PrepaidOption", "Keep the option") ))==null?'':__t)+
'</label></div><div><input type="radio" name="prepaid-option" data-input="prepaid-option-radio" id="yes" value="change"> <label class="align-left" for="yes">'+
((__t=( i18n.tc("PrepaidOption", "Change the option") ))==null?'':__t)+
'</label></div><div><input type="radio" name="prepaid-option" data-input="prepaid-option-radio" id="clear" value="clear" checked="checked"> <label class="align-left" for="clear">'+
((__t=( i18n.tc("PrepaidOption", "Remove the option") ))==null?'':__t)+
'</label></div></div> ';
 } else { 
__p+=' <legend>'+
((__t=( i18n.tc("PrepaidOption", "Should DEFA invoice the subscription to your company, or directly to the customer?") ))==null?'':__t)+
'</legend><div class="input"><div><input type="radio" name="prepaid-option" data-input="prepaid-option-radio" id="yes" value="change"> <label class="align-left" for="yes">'+
((__t=( i18n.tc("PrepaidOption", "Invoice my company (dealer agreement)") ))==null?'':__t)+
'</label></div><div><input type="radio" name="prepaid-option" data-input="prepaid-option-radio" id="no" value="skip" checked="checked"> <label class="align-left" for="no">'+
((__t=( i18n.tc("PrepaidOption", "Invoice directly to the customer") ))==null?'':__t)+
'</label></div></div> ';
 } 
__p+=' </fieldset><fieldset class="button-wrap"><button data-click="group-option-cancel">'+
((__t=( i18n.tc("PrepaidOption", "Cancel") ))==null?'':__t)+
'</button> <button class="primary" data-click="group-option-submit">'+
((__t=( i18n.tc("PrepaidOption", "Next") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
